import { assign, includes } from 'lodash'
import parser from 'ua-parser-js'

import { SEGMENT_TRACKING_BLACKLIST } from 'constants/trackingConstants'
import * as OrgSelectors from 'modules/org/selectors'
import store from 'modules/store'
import * as UserSelectors from 'modules/user/selectors'

export const track = (eventName, properties) => {
  const state = store.getState()
  const email = UserSelectors.getEmail(state)
  const orgId = OrgSelectors.getOrgId(state)

  if (!window.analytics || includes(SEGMENT_TRACKING_BLACKLIST, orgId)) {
    return
  }
  const propertiesWithEmail = assign({}, { email, orgId }, properties)
  window.analytics.track(eventName, propertiesWithEmail)
}

export const identifyUser = (
  traits = {},
  orgId = undefined,
  userId = undefined
) => {
  const state = store.getState()
  const email = UserSelectors.getEmail(state)
  const finalUserId = userId || UserSelectors.getUserId(state)
  const finalOrgId = orgId || OrgSelectors.getOrgId(state)
  const name = UserSelectors.getName(state)
  const userJwt = UserSelectors.getUserJwt(state)

  if (!finalUserId) {
    return
  }

  if (userJwt && window.drift && window.drift.setUserJwt) {
    window.drift.setUserJwt(userJwt)
  }

  return (
    window.analytics &&
    window.analytics.identify(
      `${finalOrgId}-${finalUserId}`,
      {
        name,
        email,
        orgId: finalOrgId,
        ...traits,
      },
      { integrations: { drift: { userJwt } } }
    )
  )
}

export const page = (pageName, properties = {}) => {
  const state = store.getState()
  const orgId = OrgSelectors.getOrgId(state)

  if (!window.analytics || includes(SEGMENT_TRACKING_BLACKLIST, orgId)) {
    return
  }
  window.analytics.page(pageName, properties)
}

// WARNING: DO NOT CHANGE WITHOUT CONSULTING OPS AND/OR #analytics
export const sendProductEnabled = ({ flow }) => {
  const ua = parser()

  track('Product Enabled', {
    product: flow,
    browser: ua.browser.name,
    os: ua.os.name,
  })
}

// WARNING: DO NOT CHANGE WITHOUT CONSULTING OPS AND/OR #analytics
export const bizibleTrackNewPQL = ({ email }) => {
  // Preamble for all API usage.
  window['Bizible'] = window['Bizible'] || {
    _queue: [],
    Push: function (o, p) {
      this._queue.push({ type: o, data: p })
    },
  }

  // let Bizible post this async
  window['Bizible'].Push('User', {
    eMail: email,
  })
}
